// extracted by mini-css-extract-plugin
export default {"sideLayout":"Style_sideLayout__BUZ40","content":"Style_content__tupk9","top":"Style_top__ZRC+m","cookieSettings":"Style_cookieSettings__-Gf0G"};